export const formatReadableDate = (
  isoString,
  options = { includeTime: false, locale: "en-IN" }
) => {
  if (!isoString) return "";

  const date = new Date(isoString);

  const dateOptions = {
    day: "2-digit",
    month: "long",
    year: "numeric",
    ...(options.includeTime && {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    }),
  };

  return date.toLocaleString(options.locale, dateOptions);
};

export const formatReadableDateTime = (utcDate) => {
  if (!utcDate) return "";

  const date = new Date(utcDate + "Z");

  return date.toLocaleString("en-IN", {
    timeZone: "Asia/Kolkata",
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });
};

export const toISTDateTime = (localDateTime) => {
  if (!localDateTime) return null;

  if (localDateTime.includes("Z") || localDateTime.includes("+")) {
    return localDateTime;
  }

  return localDateTime.length === 16
    ? `${localDateTime}:00+05:30`
    : `${localDateTime}+05:30`;
};

export const toDatetimeLocal = (isoString) => {
  if (!isoString) return "";

  const date = new Date(isoString);
  const pad = (n) => String(n).padStart(2, "0");

  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(
    date.getDate()
  )}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
};

export const toReadableDatetime = (datetimeLocal) => {
  if (!datetimeLocal) return "";

  const date = new Date(datetimeLocal);
  return date.toLocaleString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
};
